import {Box, Grid} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {AppState} from '../../../../../state/store';
import {getConfigurationParamByName} from '../../../../../utilities/helpers/product-helper';
import {Validators} from '../../../../../utilities/platform-helpers/validator-helper';
import {DropdownOption} from '../../../default-components/baisc-dropdown/basic-search-dropdown';
import {SelectInput} from '../../../default-components/form/select-input';
import {TextInputLabel} from '../../form/text-input-label';

const useStyles = makeStyles(() =>
  createStyles({
    formTextInputBox: {
      width: '250px',
      display: 'flex',
      justifyContent: 'center',
      [`& fieldset`]: {
        borderRadius: 0,
      },
    },
  }),
);

interface PropsFromParent {
  formName: string;
  label: string;
  hintLabel?: string;
  tooltipLabel: string;
  formOnBlur?: () => void;
  options: DropdownOption[];
  defaultValue?: Number;
  validators?: Validators;
}
export const DropdownInput: FC<PropsFromParent> = React.memo((props) => {
  const classes = useStyles();
  const selectedProduct = useSelector((store: AppState) => store.projectReducer.selectedProduct);

  return (
    <>
      <Grid item xs={7}>
        <TextInputLabel
          name={props.formName}
          label={props.label}
          hintLabel={props.hintLabel}
          tooltipLabel={props.tooltipLabel}
        />
      </Grid>
      <Grid item xs={5}>
        <Box className={classes.formTextInputBox}>
          <SelectInput
            name={props.formName}
            defaultValue={Number(getConfigurationParamByName(selectedProduct, props.formName))}
            noDefault
            validators={props.validators}
            options={props.options}
          />
        </Box>
      </Grid>
    </>
  );
});
